import LinkIcon from "@mui/icons-material/Link";

const Link = (props: any) => {
  return <LinkIcon {...props} />;
};

export default Link;
